export const OFLC_REMOVE_USER_FROM_GROUP = "OFLC_REMOVE_USER_FROM_GROUP";
export const OFLC_REMOVE_USER_FROM_GROUP_SUCCESS =
  "OFLC_REMOVE_USER_FROM_GROUP_SUCCESS";
export const OFLC_REMOVE_USER_FROM_GROUP_FAILED =
  "OFLC_REMOVE_USER_FROM_GROUP_FAILED";

export function removeUserFromGroup(payload) {
  return {
    type: OFLC_REMOVE_USER_FROM_GROUP,
    payload,
  };
}

export function removeUserFromGroupSuccess(payload) {
  return {
    type: OFLC_REMOVE_USER_FROM_GROUP_SUCCESS,
    payload: payload,
  };
}

export function removeUserFromGroupFail(payload) {
  return {
    type: OFLC_REMOVE_USER_FROM_GROUP_FAILED,
    lockedUserMessage:
      "A previous network change is still in process. Please try again later",
    payload: payload,
  };
}
